import * as React from "react";
const SvgCaret = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15 8.33333L10 13.3333L5 8.33333L6.16667 7.16666L10 11L13.8333 7.16666L15 8.33333Z", fill: "currentColor" }));
export default SvgCaret;
